import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { Logs } from 'selenium-webdriver';
import { getDocuments } from 'src/app/services/getDocuments.service';

@Component({
  selector: 'app-antecedentes-adjuntan',
  templateUrl: './antecedentes-adjuntan.component.html',
  styleUrls: ['./antecedentes-adjuntan.component.css']
})
export class AntecedentesAdjuntanComponent {
  @ViewChild('openModalMessageFiles') openModalMessageFiles: TemplateRef<any>;

  public rows = [];
  public antecedentes = new FormControl('');
  public documentosLista: string[] = [];
  public documentosMaterias: string[] = [];
  public form;
  public antecedenteTema = []
  public informacionJSON
  public selectedOptions
  formulario
  public antecedentesSeleccionados = []
  public documentos = []


  sinTipo = false


  constructor(
    private fb: FormBuilder,
    private _docs: getDocuments,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog
  ) {


    if (!JSON.parse(localStorage.getItem("tipo_solicitud"))) {
      localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("tipo_solicitud"));
    }


    this.formulario = localStorage.getItem("formId");
    if (this.formulario != '') {
      this.get_antecedentes()

    }

  }

  ngOnInit() {
    this.formulario = localStorage.getItem('form');
   /*  this.dialog.open(this.openModalMessageFiles) */
  }


  ngAfterViewChecked() {
    var sol = localStorage.getItem("formIdOK");

    if (sol == "cambiado") {
      localStorage.setItem("formIdOK", "listo")

      var x = localStorage.getItem("formId");

      if (this.formulario != x) {
        this.formulario = localStorage.getItem("formId");
        this.get_antecedentes()
      }

    }

  }





  get_antecedentes() {
    this._docs.getAntecedentesAdjuntan().subscribe(
      data => {
        this.informacionJSON = data;
        this.antecedenteTema = []



        for (let i = 0; i < this.informacionJSON.length; i++) {
          const filaFormulario = this.informacionJSON[i];

          if (filaFormulario.Cod == this.formulario) {
            this.documentosMaterias = filaFormulario.Materias

            /*   this.documentosLista = filaFormulario.Materias */
            for (let e = 0; e < filaFormulario.Materias.length; e++) {
              const materiaFormulario = filaFormulario.Materias[e];

              for (let f = 0; f < materiaFormulario.Docs.length; f++) {
                const documentoFinal = materiaFormulario.Docs[f];

                this.antecedenteTema.push(documentoFinal)
              }
            }
          }
        }

        this.documentosLista = this.antecedenteTema
        console.log(this.documentosLista);


      },
      error => {
        console.log(error)
      })
  }



  onNgModelChange(event) {
    this.antecedentesSeleccionados = event
    localStorage.setItem("antecedentes", JSON.stringify(event));
    localStorage.setItem("antecedentes_status", "cambiado");
  }


  cerrarModal() {
    this.dialog.closeAll();
}

}
